export default "__VITE_ASSET__686fa3e4__"